import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import type { IUseTerritoryTrailResult } from './use-territory-trail.types'
import {
  getGlobalTaxonomyTerritoryIdFromPathname,
  getTerritoryTrailSearch,
  parseTerritoryTrail,
} from '../../global-topic.utils'

export const useTerritoryTrail = (): IUseTerritoryTrailResult => {
  const { pathname, search } = useLocation()

  return useMemo(() => {
    const trailIds = parseTerritoryTrail(search)
    const currentTerritoryId = getGlobalTaxonomyTerritoryIdFromPathname(pathname)
    const childTrailIds = currentTerritoryId ? [...trailIds, currentTerritoryId] : trailIds

    return { trailIds, childTrailSearch: getTerritoryTrailSearch(childTrailIds) }
  }, [pathname, search])
}
